import api from ".";
import ITag from "../typings/ITag";
import http from "./client";
import { IGetStudentsQueryParams } from "./students";


interface IQueryParamsDefault {
  id: number | string;
  course_id: number | string;
}
export interface IStudentTagsByCourseQueryParams {
  course_id?: number | string;
  group_id?: number | string;
  sortBy?: 'tag' | 'author' | 'students';
  order?: 'asc' | 'desc';
  withStudentsCount?: boolean;
  search?: string;
}

interface ITagsResponse {
  success: boolean;
  errorMessage?: string;
  paginator?: {
    limit: number;
    page: number;
    pageCount: number;
    totalItemCount: number;
  },
  metaData?: any;
  data?: Array<ITag>;
}

async function list(queryParams: IStudentTagsByCourseQueryParams): Promise<ITagsResponse> {
  const response = await http.get<ITagsResponse>('/api/tag/list', {
    params: queryParams
  })
  return response.data;
}

async function byUser(users: Array<number | string>) {
  const resp = await http.get('/api/tag/by-user', {
    params: {
      users: users
    }
  });

  return resp.data.data;
}

async function edit(tag: ITag, course_id: string | number) {
  await http.post(`/api/tag/save?id=${tag.id}&course_id=${course_id}`, tag);
}

async function remove(queryParams: IQueryParamsDefault) {
  await http.post(`/api/tag/delete`,undefined, {
    params: queryParams
  });
}

async function copy(queryParams: IQueryParamsDefault): Promise<ITag> {
  const response = await http.post(`/api/tag/copy`, undefined, {
    params: queryParams
  });
  return response.data.data;
}

async function create(course_id: string| number = null, name?: string): Promise<ITag> {
  const response = await http.post(`/api/tag/save`, {
    tag: name ? name : 'Новый тег',
    color: '#2f90e0'
  }, {
    params: {
      course_id: course_id
    }
  });
  return response.data.data;
}


 async function linkAll(userSortParams: Omit<IGetStudentsQueryParams, 'page'>, course_id:number|string, tags:Array<number | string>): Promise<boolean> {
  const response = await http.post(`/api/tag/link-all`, {
    'filter': userSortParams,
    course_id,
    tags
  });
  return response.data.success;
}


async function unlinkAll(tags:Array<string | number>): Promise<ITag> {
  const response = await http.post(`/api/tag/unlink-all`, {
    tags
  });
  return response.data;
}

/**
 * Добавляем к пользователям теги
 * @param users id пользователей
 * @param tags id тегов
 */
async function link(users: Array<number | string>, tags:Array<number | string>): Promise<boolean> {
  const response = await http.post(`/api/tag/link`, {
    users,
    tags
  });
  return response.data.success;
}

/**
 * Удаляет связь пользователей и тегов
 * @param users id пользователей
 * @param tags id или названия тегов
 */
async function unlink(users: Array<number | string>, tags:Array<string | number>): Promise<ITag> {
  const response = await http.post(`/api/tag/unlink`, {
    users,
    tags
  });
  return response.data;
}

async function importFile(file: File) {
  return await api.file.uploadTemp(file);
}

const tags = {
  list, byUser, remove, edit, copy, create, importFile, link, unlink, unlinkAll, linkAll
}

export default tags;